// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"944757d4","787":"4e27f903"}[chunkId] + ".chunk.js";
};